import { NgModule } from '@angular/core';

import { AwsModule } from '../aws/aws.module';
import { MQTTService } from './mqtt.service';

@NgModule({
    imports: [AwsModule],
    declarations: [],
    providers: [MQTTService],
    exports: [
    ]
})
export class MQTTModule { }


// WEBPACK FOOTER //
// ./src/app/mqtt/mqtt.module.ts